import {InjectionToken} from '@angular/core';

export const LAYOUT_CONFIGURE = new InjectionToken('#im/layout/configure');